import {handleSliders} from '@/scripts/optional/problem-solution';

document.addEventListener('DOMContentLoaded', () => {
	handleSliders();
})

